//#region Styles
import { 
    Column,
    RequiredAsterisk,
    Row } from "components/styles";
import {
    Container,
    Description,
    Box
} from "./styles";
//#endregion
// #region Components
import ErrorMessage from "components/ErrorMessage/ErrorMessage";
import BoxIcon from "./icons/BoxIcon";
import { useEffect, useRef } from "react";
// #endregion

const classNames = {
    box: "box",
    square: "square",
    switch: "switch"
};
export const CustomCheckbox = ({
    variant = "box", size,
    padding, label, labelColor,
    onChange, checked,
    error, disabled,
}) => {
    //#region Functions
    const getClassName = () => {
        const classList = [];
        classList.push(classNames[variant] || classNames.box);
        error && classList.push("error");
        disabled && classList.push("disabled");
        size && classList.push(size);
        return classList.join(" ");
    }
    const getBoxClassName = () => {
        const classList = ["box"];
        checked && classList.push("checked");
        disabled && classList.push("disabled");
        return classList.join(" ");
    }
    //#endregion
    return (
        <Container 
            className={getClassName()}
            padding={padding}
            labelColor={labelColor}
            onClick={() => (!disabled && onChange) && onChange()}>
            {variant === "switch" 
                ? <div className={checked ? "checked" : ""}>
                </div>
                : <Box className={getBoxClassName()}>
                    <BoxIcon/>
                </Box>}
            <label>{label}</label>
        </Container>
    );
}

const HandlerCheckbox = ({
    onChange, 
    checkboxProps = [],
    variant, gap = "8px",
    error = false,
    errorText,
    description, required,
    disabled,
    start,
    end,
    startId,
    endId,
    isCreate
}) => {
    //useEffect(() => {
    //     onChange(startId)
    //}, [startId]);
    //useEffect(() => {
    //     onChange(endId)
    //}, [endId]);

    const getDayId = (date) => {
        if(date > 0){
            let dayId = new Date(date).getDay();
            dayId = dayId === 0 ? 7 : dayId;
            return dayId;
        }else{
            return -1;
        }
    }
    return (
        <Column width="unset">
            {description && 
            <Row gap="5px">
                <Description className={disabled ? "disabled" : ""}>{description}</Description>
                {required && <RequiredAsterisk>*</RequiredAsterisk>}
            </Row>}
            <Row className="flex-start" gap={gap}>
                {checkboxProps.map(({
                        label,
                        checked, 
                        ...restProps
                    }, idx) => {
                    return (
                        <CustomCheckbox  
                            key={idx} 
                            {...restProps}
                            variant={variant}
                            label={label}
                            onChange={() => onChange(restProps.value)}
                            checked={checked}
                            disabled={(typeof disabled === "boolean" 
                                ? disabled 
                                : restProps?.disabled)
                                //restProps.value == getDayId(start) || restProps.value == getDayId(end)
                            }
                            error={error}
                            />
                    );
                })}
            </Row>
            <ErrorMessage 
                text={errorText}
                error={error}/>
        </Column>
    );
}

export default HandlerCheckbox;